// babel-polyfill按需引入
import 'core-js/es7/set';
import 'core-js/es7/promise';
import 'core-js/es7/array';
import 'core-js/es7/string';
import 'core-js/es7/object';
import 'regenerator-runtime/runtime';

import Vue from 'vue';
import App from './App';
import router from './router';
import store from './store';
import request from './api/request';
import importVue from './utils/importVue';
import './assets/styles/index.less';

importVue(Vue);
Vue.use(request);

const app = new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
});

window.$app = app;

export default app;
